import { fetchWithRefresh, request } from '../../utils/api';
import {
    PASSWORD_RESTORE_PATH,
    PASSWORD_RESET_PATH,
    REGISTER_PATH,
    LOGIN_PATH,
    LOGOUT_PATH,
    USER_PATH,
    API_BASE,
} from '../../utils/constants';
import { AppThunk } from '../../utils/store-types';
import {
    TLogin,
    TPasswordResetResponse,
    TPatchUser,
    TRegisterResponse,
    TUserForm,
    TUserResponse,
} from '../../utils/types';
import {
    getPasswordRestoreSuccess,
    getPasswordRestoreFailed,
    getPasswordResetClear,
    getPasswordResetSuccess,
    getPasswordResetFailed,
    getRegisterSuccess,
    getRegisterFailed,
    getLoginSuccess,
    getLoginFailed,
    getUserSuccess,
    getUserFailed,
    setUser,
    getUserUpdateSuccess,
    getUserUpdateFailed,
    checkedAuth,
} from '../actions/auth-actions';

export function getRestorePassword(email: string): AppThunk {
    return (dispatch) => {
        request(`${API_BASE}${PASSWORD_RESTORE_PATH}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email,
            }),
        })
            .then(() => {
                dispatch(getPasswordRestoreSuccess());
            })
            .catch((err) => {
                dispatch(getPasswordRestoreFailed(err));
            });
    };
}

export function getResetPassword(password: string, token: string): AppThunk {
    return (dispatch) => {
        dispatch(getPasswordResetClear());
        request<TPasswordResetResponse>(`${API_BASE}${PASSWORD_RESET_PATH}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                password,
                token,
            }),
        })
            .then((data) => {
                dispatch(getPasswordResetSuccess(data));
            })
            .catch((err) => {
                dispatch(getPasswordResetFailed(err));
            });
    };
}

export function getRegister(form: TUserForm): AppThunk {
    return (dispatch) => {
        request<TRegisterResponse>(`${API_BASE}${REGISTER_PATH}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(form),
        })
            .then((data) => {
                dispatch(getRegisterSuccess(data));
            })
            .catch((err) => {
                dispatch(getRegisterFailed(err));
            });
    };
}
export function getLogin(form: TLogin): AppThunk {
    return (dispatch) => {
        request<TRegisterResponse>(`${API_BASE}${LOGIN_PATH}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(form),
        })
            .then((data) => {
                if (data.success) dispatch(getLoginSuccess(data));
                else dispatch(getLoginFailed(''));
            })
            .catch((err) => {
                dispatch(getLoginFailed(err));
            });
    };
}
export function getUser(): AppThunk<Promise<void>> {
    return (dispatch) => {
        const { accessToken } = localStorage;
        if (accessToken)
            return fetchWithRefresh<TUserResponse>(`${API_BASE}${USER_PATH}`, {
                // method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((data) => {
                    if (data.success) {
                        dispatch(getUserSuccess(data));
                    } else {
                        delete localStorage.accessToken;
                    }
                })
                .catch(() => {});
        dispatch(getUserFailed());
        return new Promise(() => {});
    };
}
export function checkAuth(): AppThunk {
    return (dispatch) => {
        const { accessToken } = localStorage;
        if (accessToken) {
            dispatch(getUser()).finally(() => dispatch(checkedAuth()));
        } else dispatch(checkedAuth());
    };
}
export function patchUser(form: TPatchUser): AppThunk {
    return (dispatch) => {
        const { accessToken } = localStorage;
        fetchWithRefresh(`${API_BASE}${USER_PATH}`, {
            method: 'PATCH',
            mode: 'cors',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(form),
        })
            .then(() => {
                dispatch(getUserUpdateSuccess());
            })
            .catch((err) => {
                dispatch(getUserUpdateFailed(err));
            });
    };
}
export function getLogout(): AppThunk {
    return (dispatch) => {
        const { refreshToken } = localStorage;
        if (refreshToken)
            request(`${API_BASE}${LOGOUT_PATH}`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: refreshToken }),
            }).catch(() => {});
        dispatch(setUser(null));
        localStorage.clear();
    };
}
